import Alpine from 'alpinejs';

Alpine.data('header', () => ({
    init() {
        // The header is cached once for the whole site, therefore, we set the active state via JS
        let activeLink = this.$root.querySelector(
            'a[href="' + location.pathname + '"], a[href="' + location.origin + '/' + location.pathname + '"]'
        );
        let activeLi = activeLink?.closest('li');
        while (activeLi) {
            activeLi.classList.add('link-underline');
            activeLi = activeLi.parentElement.closest('li');
        }
    },
    mobileMenuIsOpen: false,
    isAtTop: window.pageYOffset < 20,
}));
